import angular from 'angular';
import adminPermissionsComponent from './adminPermissions.component';
import adminPermissionsService from './adminPermissions.service';



let adminPermissionsModule = angular.module('adminPermissions', [])
  .component('adminPermissions', adminPermissionsComponent)
  .service('adminPermissionsService', adminPermissionsService);

export default adminPermissionsModule;



// WEBPACK FOOTER //
// ./app/components/adminPermissions/adminPermissions.js